<template>
  <StandardDialogFullScreen opacity="1" v-if="waggon">
    <template #dialog>
      <router-view
        v-if="$route.matched[3] && $route.matched[3].name !== 'WorkBenchWaggonWorkPackageAdd'"
        style="z-index: 20; background-color: red;"
        />
    </template>
    <template #header-workpackages>
      <StandardDialog v-if="show_dialog" @click-outside="show_dialog=false">
        <template #content>
          <v-card color="secondary" height="100%" class="d-flex flex-column">
            <v-card-title>
              {{$t('WorkBench.Editor.Download.Header').replace('Sequence', 'Wagon')}}
            </v-card-title>
            <v-card-text>
              {{$t('WorkBench.Editor.Download.Text').replace('sequence', 'wagon')}}
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn v-if="template_type==='community'" @click="createWBObject({
                url: [
                  {waggons: '0/copyfromcommunity'},
                  {showWithEntitiesNormalized: ''},
                ],
                wb_object: {
                  cwaggon: waggon.id,
                  copy_workpackages: true
                }
              }).then(() => {
                waggon.likes.some(like => like.user.id === getUserId)?
                show_dialog=false:
                updateWBObject({
                  url: [
                  {cwaggons: waggon.id},
                  {like: ''},
                  ],
                  update: {
                    likes: getLikes(waggon.likes)
                  }
                }).then(() => { show_dialog=false; })
              })" color="green" text>{{$t('WorkBench.Editor.Download.WithWorkPackages').replace('Sequence', 'wagon')}}</v-btn>

              <v-btn v-if="template_type==='community'" @click="createWBObject({
                url: [
                  {waggons: '0/copyfromcommunity'},
                  {showWithEntitiesNormalized: ''},
                ],
                wb_object: {
                  cwaggon: waggon.id,
                  copy_workpackages: false
                }
              }).then(() => {
                waggon.likes.some(like => like.user.id === getUserId)?
                show_dialog=false:
                updateWBObject({
                  url: [
                  {cwaggons: waggon.id},
                  {like: ''},
                  ],
                  update: {
                    likes: getLikes(waggon.likes)
                  }
                }).then(() => { show_dialog=false; })
              })" color="green" text>{{$t('WorkBench.Editor.Download.WithoutWorkPackages').replace('Sequence', 'wagon')}}</v-btn>

              <!-- BUSINESS -->
              <v-btn v-if="template_type==='company'" @click="createWBObject({
                url: [
                  {waggons: '0/copyfrombusiness'},
                  {showWithEntitiesNormalized: ''},
                ],
                wb_object: {
                  bwaggon: waggon.id,
                  copy_workpackages: true
                }
              }).then(() => {
                waggon.likes.some(like => like.user.id === getUserId)?
                show_dialog=false:
                updateWBObject({
                  url: [
                  {bwaggons: waggon.id},
                  {like: ''},
                  ],
                  update: {
                    likes: getLikes(waggon.likes)
                  }
                }).then(() => { show_dialog=false; })
              })" color="green" text>{{$t('WorkBench.Editor.Download.WithWorkPackages').replace('Sequence', 'wagon')}}</v-btn>

              <v-btn v-if="template_type==='company'" @click="createWBObject({
                url: [
                  {waggons: '0/copyfrombusiness'},
                  {showWithEntitiesNormalized: ''},
                ],
                wb_object: {
                  bwaggon: waggon.id,
                  copy_workpackages: false
                }
              }).then(() => {
                waggon.likes.some(like => like.user.id === getUserId)?
                show_dialog=false:
                updateWBObject({
                  url: [
                  {bwaggons: waggon.id},
                  {like: ''},
                  ],
                  update: {
                    likes: getLikes(waggon.likes)
                  }
                }).then(() => { show_dialog=false; })
              })" color="green" text>{{$t('WorkBench.Editor.Download.WithoutWorkPackages').replace('Sequence', 'wagon')}}</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="show_dialog=false" color="red" text>Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </StandardDialog>
      <StandardFlexBox
        v-if="!create"
        direction="column"
        class="font-weight-light"
      >
        <TText 
          value="Creator{colon} {firstName} {lastName} - {email}" 
          :value_props="{
            colon: ':',
            firstName: waggon.owner.first_name,
            lastName: waggon.owner.last_name,
            email: waggon.owner.email,
          }"
          font_weight="400"
        />
      </StandardFlexBox>
      <StandardFlexBox
        class="font-weight-light ml-6"
        width="calc(100vw - 450px)"
        >
        <StandardDataField
          v-for="(hashtag, index) in waggon.hashtags"
          :key="index"
          class="user-select-none ml-1"
          :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          one_liner="true"
          readonly="true"
          :value="hashtag.tag"
          width="24%"
          >
          <template #prepend-slot>
            <div class="user-select-none">#</div>
          </template>
          <template #append-slot>
            <StandardDeleteButton
              :zoom="1"
              @clickDelete="
              create?
              deleteWBLObject({
                path: [
                  {waggon: ''},
                  {hashtags: ''}
                ],
                index: index
                })
              :
              removeHashtag(index)
              "
              />
          </template>
        </StandardDataField>
        <StandardDataField
          v-if="!read_only"
          class="ml-1"
          :key="`addhashtag_${update_key_add_hashtag}`"
          :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          one_liner="true"
          @changeValue="
          create?
          createWBLObject({
            path: [
              {waggon: ''},
              {hashtags: ''}
            ],
            wbl_object: {
              tag: $event.replace(/\s/g,'')
            }
            })
          :
          addHashtag($event),
          update_key_add_hashtag++
          "
        >
        <template #prepend-slot>
          <div class="user-select-none">#</div>
        </template>
        </StandardDataField>
      </StandardFlexBox>
    </template>
    <template #header-close>
      <template v-if="!create">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon
              @click="$router.push({
                name: `${location}Waggons`
                })"
              v-on="on"
              v-bind="attrs"
              >
              <v-icon color="green">done</v-icon>
            </v-btn>
          </template>
          <span>{{$t('WorkBench.Editor.Waggon.Toolbar.done')}}</span>
          </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-on="on"
            v-bind="attrs"
            v-if="!read_only && $route.params.template_type === 'custom'"
            @click="createWBObject({
              url: [
                {[`${prefix}waggons`]: waggon.id},
                {copyOwnWaggon: ''}
              ],
              wb_object: {
                cwaggon: waggon.id
              },
              url_suffix: '?show=showWithEntitiesNormalized'
              }).then(() => {
                $router.push({
                  name: `${location}Waggons`
                })
              })"
            >
          <v-icon>content_copy</v-icon>
        </v-btn>
      </template>
      <span>{{$t('WorkBench.Editor.Waggon.Toolbar.copy')}}</span>
      </v-tooltip>
        <TUploadButton
          v-if="!read_only"
          icon="people"
          :value="waggon.is_community_suggested"
          :tooltip="$t('WorkBench.Editor.Waggon.Toolbar.uploadToCommunity')"
          @upload="updateWBObject({
            url: [
              {[`${prefix}waggons`]: waggon_id},
            ],
            update: {
              is_community_suggested: true
            }
          })"
        />
        <template v-if="template_type === 'community'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                :color="waggon.likes.some(like => like.user.id === getUserId)?'blue':'grey'"
                v-on="on"
                v-bind="attrs"
                @click="show_dialog=true"
              >
                <v-icon class="mr-5">download</v-icon>
                {{waggon.likes.length}}
              </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Waggon.Toolbar.download')}}</span>
          </v-tooltip>
        </template>
        <template v-if="template_type === 'company'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                :color="waggon.likes.some(like => like.user.id === getUserId)?'blue':'grey'"
                v-on="on"
                v-bind="attrs"
                @click="show_dialog=true"
                >
                <v-icon class="mr-5">download</v-icon>
                {{waggon.likes.length}}
              </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Waggon.Toolbar.download')}}</span>
          </v-tooltip>
        </template>
        <template v-if="!read_only && hasPermission('Business READ') && template_type !== 'company'">
          <TUploadButton
            icon="work"
            :counter="getWBObjectsFiltered({type: 'bwaggons',
              filter: {
                token: waggon.token,
                owner: waggon.owner
              }
            }).length"
            :tooltip="$t('WorkBench.Editor.Waggon.Toolbar.uploadToCompany')"
            @upload="createWBObject({
                url: [
                  {bwaggons: 'createfromwaggon'},
                  {showWithEntitiesNormalized: ''}
                ],
                template_type: 'company',
                wb_object: {
                  waggon_id: waggon.id
                }
              })"
          />
        </template>
        <StandardDeleteBtn
          v-if="
            !read_only ||
            (template_type === 'company' && hasPermission('BSequence DELETE')) ||
            (template_type === 'community' && hasPermission('CSequence DELETE'))
            "
          :tooltip="$t('WorkBench.Editor.Waggon.Toolbar.delete')"
          :el="waggon"
          @deleteClick="deleteWBObject({
                url: [
                  {[`${prefix}waggons`]: waggon.id}
                ]
              }),
              $router.push({
                name: `${location}Waggons`
                })"
          />
      </template>
      <template v-else>
        <v-btn
          color="orange"
          @click="
          resetWaggon()"
          >
          <v-icon
            >
          restart_alt
        </v-icon>
          Reset
        </v-btn>
        <v-spacer/>
        <v-btn
          class="ml-2"
          color="green"
          @click="
          loading = true,
          createWBObject({
              url: [
                {waggons: ''},
                {showWithEntitiesNormalized: ''}
              ],
              wb_object: getWaggonForCreateCall()
            }).then((id) => {
              uploadWaggonWorkpackagesImageBulk(id)
              })
            "
          >
          <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          />
          {{$t('Buttons.Create')}}
        </v-btn>
        <v-btn
          depressed
          class="ml-2"
          color="grey darken-4"
          @click="$router.push({
            name: `${location}Waggons`
            })"
          >
          {{$t('Buttons.Cancel')}}
        </v-btn>
      </template>
    </template>
    <template #content>
      <StandardFlexBox
        class="mb-1"
        style="position: relative"
        width="100%"
        height="346px"
        direction="column"
        >
        <!-- waggon -->
        <StandardFlexBox
          class="mr-1 ml-1 mt-1 overflow-visible"
          height="42px"
          style="position: relative"
          no_wrap="true"
        >
          <Waggon
            @click.native=" waggon[`${prefix}wagworkpackages`].length === 0 ? $router.push({
              name: `${location}WaggonWorkPackageAdd`,
              params: {
                waggon_id: create ? 'create' : waggon.id,
              }
            }) : ''"
            :workpackage_count="waggon[`${prefix}wagworkpackages`].length"
            class="cursor-pointer"
            :style="`${
                    ($route.matched[3] && $route.matched[3].name === `${location}WaggonWorkPackageAdd` &&
                    $route.params.waggon_id === (create?0:waggon.id))
                    || !$route.matched[3] && wagworkpackage_rec_pos === 0 ||
                    wagworkpackage_rec_pos !== 0 && (wagworkpackage_rec_pos === 0+1 || wagworkpackage_rec_pos === 0+2) ||
                    wagworkpackage_rec_pos !== 0 && wagworkpackage_rec_pos > waggon[`${prefix}wagworkpackages`].length && 0 === waggon[`${prefix}wagworkpackages`].length-1
                    ?
                    '': 'opacity: 0.5;'
                    }
                    transition: opacity 0.2s ease-in-out;
                     `
                    "
            :zoom="4"
            >
            <template #content>
              <Workpackage
                v-for="(workpackage, workpackage_index) in create?waggon.wagworkpackages:getWBObjects({type: `${prefix}wagworkpackages`, ids: waggon[`${prefix}wagworkpackages`]})"
                :key="`workpackage${create?workpackage_index:workpackage.id}`"
                :workpackage_count="waggon[`${prefix}wagworkpackages`].length"
                :workpackage="workpackage"
                :zoom="4"
                @click.native="workpackageTestClick(workpackage_index)"
              />
            </template>
          </Waggon>
        </StandardFlexBox>
      </StandardFlexBox>
      <!-- bottom box -->
      <StandardFlexBox
        :class="`ml-1 mr-1 pa-1 t-rounded t-shadow font-weight-light ${$vuetify.theme.isDark ? 'grey darken-4' : 'grey lighten-3'}`"
        height="calc(100% - 350px)"
        >
        <!-- TEMPLATE FOR ONLY WORK PACKAGE ADD START -->
        <template v-if="$route.matched[3] && $route.matched[3].name === 'WorkBenchWaggonWorkPackageAdd'">
          <!-- AI RECOMMENDATION BOX START -->

          <!-- AI RECOMMENDATION BOX END -->

          <!-- ROUTER VIEW BOX START -->
          <!-- v-if="$route.matched[3] && $route.matched[3].name === 'WorkBenchWaggonWorkPackageAdd'" -->
          <StandardFlexBox
            class="cursor-pointer"
            height="100%"
            width="40px"
            direction="column"
            justify_content="center"
            align_content="center"
            @click.native="$router.push({name: `${location}WaggonEditor`})"
          >
            <v-icon>keyboard_arrow_left</v-icon>
          </StandardFlexBox>
          <StandardFlexBox
            height="100%"
            width="calc(100% - 40px)"
            direction="column"
            justify_content="space-between"
            >
            <router-view
              style="z-index: 20"
              />
          </StandardFlexBox>
          <!-- ROUTER VIEW BOX START -->

          <!-- v-if="$route.matched[3] && $route.matched[3].name === 'WorkBenchWaggonWorkPackageAdd'" -->
        </template>
        <!-- TEMPLATE FOR ONLY WORK PACKAGE ADD END -->
        <!-- BOX WITH WAGON NAME START -->
        <StandardFlexBox
          v-else
          class="pa-1"
          width="30%"
          height="100%"
          >
          <StandardDataField
            placeholder="token"
            width="100%"
            height="26px"
            :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
            :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
            :value="waggon.token"
            :readonly="read_only"
            :maxlength="5"
            @changeValue="
            create?
            updateWBLObject({
              path: [
                {waggon: ''},
              ],
              update: {
                token: $event
              }
              })
            :
            updateWBObject({
              url: [
                {[`${prefix}waggons`]: waggon_id},
              ],
              update: {
                token: $event
              }
            })"
          />
        </StandardFlexBox>
        <!-- BOX WITH WAGON NAME START -->
      </StandardFlexBox>
    </template>
  </StandardDialogFullScreen>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  // import store from '@/store/index';
  import { WorkBenchWaggonMixin } from '@/mixins/WorkBenchWaggon.mixin.js'
  export default {
    props: [
      'waggon_id',
      'location',
      'template_type',
      'create',
      'read_only',
    ],
    mixins: [
      WorkBenchWaggonMixin,
    ],
    data: () => ({
      loading: false,
      show_dialog: false
    }),
    computed: {
      ...mapGetters('Auth', [
        'getUser',
        'hasPermission'
      ])
    },
    created() {
      // console.log('template_type', this.template_type);
    },
    watch: {
      'waggon.wagworkpackages'() {
        // if (!this.read_only) {
        //   this.ai_animation_recommendation = true;
        //   store.dispatch('WorkBench/createWBObject', {
        //     url: [
        //       {ai: 'wagworkpackagerecommendations'},
        //     ],
        //     wb_object:
        //       this.create?
        //         store.getters['WorkBenchLocal/getAISequenceWaggonsLocal']({
        //           waggon_id: this.$route.params.waggon_id,
        //           complete_waggon: true
        //         })
        //         :
        //         store.getters['WorkBench/getAISequenceWaggons']({
        //           waggon_id: this.$route.params.waggon_id,
        //           complete_waggon: true,
        //           prefix: this.prefix,
        //         })
        //   }).then(() => {
        //     this.ai_animation_recommendation = false;
        //   });
        // }
      },
      'waggon.bwagworkpackages'() {
        // if (!this.read_only) {
        //   this.ai_animation_recommendation = true;
        //   store.dispatch('WorkBench/createWBObject', {
        //     url: [
        //       {ai: 'wagworkpackagerecommendations'},
        //     ],
        //     wb_object:
        //       this.create?
        //         store.getters['WorkBenchLocal/getAISequenceWaggonsLocal']({
        //           waggon_id: this.$route.params.waggon_id,
        //           prefix: this.prefix,
        //           complete_waggon: true
        //         })
        //         :
        //         store.getters['WorkBench/getAISequenceWaggons']({
        //           waggon_id: this.$route.params.waggon_id,
        //           complete_waggon: true,
        //           prefix: this.prefix,
        //         })
        //   }).then(() => {
        //     this.ai_animation_recommendation = false;
        //   });
        // }
      }
    },
    methods: {
      ...mapActions('View', [
        'setMacroView'
      ]),
      workpackageTestClick(workpackage_index){
        let params;
        if (this.create) {
           params = {
            // waggon_id: this.waggon_id,
            workpackage_id: workpackage_index
          };
        } else {
          params = {
            // waggon_id: this.waggon_id,
            workpackage_id: this.waggon[`${this.prefix}wagworkpackages`][workpackage_index]
          };
        }
        this.$router.push({
          name: `${this.location}WaggonWorkPackage`,
          params: params
        });
      }
    }
  }
</script>
<style>
  .grow-x-enter, .grow-x-leave-to {
    width: 0px;
  }
  .grow-x-enter-active, .grow-x-leave-active {
    overflow: hidden;
    transition: all 0.1s ease-in-out;
  }
  .makro-view {
    height: 100%;
    width: 100%;
    background-color: rgb(138 138 138 / 50%);
    position: absolute;
    z-index: 2;
    text-align: center;
    padding-top: 7px;
  }
</style>
